<template>
  <div>
    <v-btn small color="primary" @click="abrirDialog()">
      <v-icon small>mdi-plus</v-icon>
      Novo
    </v-btn>

    <SysDialog
      v-model="COMPUTED_DIALOG"
      :titulo="COMPUTED_TITULO_DIALOG"
      :txt-botao="COMPUTED_TEXTO_BOTAO"
      @click:primary="avancarEtapa()"
      @click:hidden-dialog="resetEvento()"
    >
      <v-card class="elevation-0 ma-0 pa-0">
        <v-card-text class="ma-0 pa-0">
          <v-text-field
            ref="nome"
            v-model="COMPUTED_FORM.nome_evento"
            label="Nome do Evento"
            placeholder="Nome do Evento"
            required
            outlined
            :error-messages="ERROR_NOME_EVENTO"
            @input="$v.COMPUTED_FORM.nome_evento.$touch()"
            @blur="$v.COMPUTED_FORM.nome_evento.$touch()"
            @change="$v.COMPUTED_FORM.nome_evento.$touch()"
          />

          <v-row>
            <v-col>
              <v-menu
                ref="menu_data_inicial"
                v-model="menu_data_inicial"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    ref="data_inicial"
                    :value="COMPUTED_DATA_FORMATADA_INICIAL"
                    label="Data inicial do evento"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    :error-messages="ERROR_DATA_INICIAL"
                    @input="$v.COMPUTED_FORM.data_inicial.$touch()"
                    @blur="$v.COMPUTED_FORM.data_inicial.$touch()"
                    @click:append="menu_data_inicial = true"
                  />
                </template>
                <v-date-picker
                  v-model="COMPUTED_FORM.data_inicial"
                  no-title
                  @input="menu_data_inicial = false"
                  :min="COMPUTED_DATA_ATUAL_MIN"
                />
              </v-menu>
            </v-col>

            <v-col>
              <v-menu
                ref="menu_data_final"
                v-model="menu_data_final"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    ref="data_final"
                    :value="COMPUTED_DATA_FORMATADA_FINAL"
                    label="Data final do evento"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    :error-messages="ERROR_DATA_FINAL"
                    @input="$v.COMPUTED_FORM.data_final.$touch()"
                    @blur="$v.COMPUTED_FORM.data_final.$touch()"
                    @click:append="menu_data_final = true"
                  />
                </template>
                <v-date-picker
                  v-model="COMPUTED_FORM.data_final"
                  no-title
                  @input="menu_data_final = false"
                  :min="COMPUTED_DATA_ATUAL_MAX"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </SysDialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import { required } from "vuelidate/lib/validators";
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';

export default {
  components: { SysDialog },
  data: () => ({
    menu_data_inicial: false,
    menu_data_final: false,
  }),
  watch: {
    "COMPUTED_FORM.data_inicial"(valor) {
      if (!valor) return;
      this.COMPUTED_FORM.data_final = moment(valor).add(1, 'days').format('YYYY-MM-DD');
    },
  },
  computed: {
    ...mapGetters({
      GET_DIALOG_NOVO_EVENTO: 'EventoSazonalFinal/GET_DIALOG_NOVO_EVENTO',
      GET_FORM_NOVO_EVENTO: 'EventoSazonalFinal/GET_FORM_NOVO_EVENTO',
    }),
    COMPUTED_DIALOG: {
      get() { return this.GET_DIALOG_NOVO_EVENTO },
      set(value) { this.$store.dispatch('EventoSazonalFinal/setDialogNovoEvento', value) }
    },
    COMPUTED_FORM: {
      get() { return this.GET_FORM_NOVO_EVENTO },
      set(value) { this.$store.dispatch('EventoSazonalFinal/setFormNovoEvento', value) }
    },
    COMPUTED_TITULO_DIALOG() {
      return this.GET_FORM_NOVO_EVENTO.id == '' ? 'Novo Evento' : `Editar o evento: ${this.GET_FORM_NOVO_EVENTO.nome_evento}`;
    },
    COMPUTED_TEXTO_BOTAO() {
      return 'avançar';
    },
    COMPUTED_DATA_FORMATADA_INICIAL() {
      return this.formatarData(this.COMPUTED_FORM.data_inicial)
    },
    COMPUTED_DATA_FORMATADA_FINAL() {
      return this.formatarData(this.COMPUTED_FORM.data_final)
    },
    COMPUTED_DATA_ATUAL_MIN() {
      return moment().format('YYYY-MM-DD');
    },
    COMPUTED_DATA_ATUAL_MAX() {
      return this.COMPUTED_FORM.data_inicial
        ? moment(this.COMPUTED_FORM.data_inicial).add(1, 'days').format('YYYY-MM-DD')
        : moment().format('YYYY-MM-DD');
    },
    ERROR_NOME_EVENTO() {
      const errors = [];
      if (!this.$v.COMPUTED_FORM.nome_evento.$dirty) return errors;
      !this.$v.COMPUTED_FORM.nome_evento.required && errors.push("Campo obrigatório.");
      return errors;
    },
    ERROR_DATA_INICIAL() {
      const errors = [];
      if (!this.$v.COMPUTED_FORM.data_inicial.$dirty) return errors;
      !this.$v.COMPUTED_FORM.data_inicial.required && errors.push("Campo obrigatório.");
      return errors;
    },
    ERROR_DATA_FINAL() {
      const errors = [];
      if (!this.$v.COMPUTED_FORM.data_final.$dirty) return errors;
      !this.$v.COMPUTED_FORM.data_final.required && errors.push("Campo obrigatório.");
      return errors;
    },
  },
  methods: {
    abrirDialog() {
      this.COMPUTED_DIALOG = true
    },
    avancarEtapa() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      this.$store.dispatch('EventoSazonalFinal/setDialogGraficoTabela', true);
    },
    resetEvento() {
      this.$v.$reset();
      this.COMPUTED_FORM = {
        id: '',
        nome_evento: '',
        data_inicial: '',
        data_final: '',
      }
    },
    formatarData (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
  },
  validations: {
    COMPUTED_FORM: {
      nome_evento: { required },
      data_inicial: { required },
      data_final: { required },
    }
  }
}
</script>

<style>

</style>
